import React, { useState, useEffect, useCallback } from "react";
import EnhancedTable from "js/components/Shared/Tabla/EnhancedTable";
import DefaultFilter from "js/components/Shared/Tabla/DefaultFilter";
import Header from "js/components/Shared/Tabla/Header";
import ButtonBar from "js/components/Shared/Tabla/ActionButtons";
import PropTypes from "prop-types";
import FilterService from "js/utils/FilterService";
import { size } from "lodash";
import { plainObject } from "js/utils/Helper";
import SplashScreen from "js/pages/SplashScreen";
import AuthService from "js/utils/AuthService";
import { USER_ROLES as Roles } from "js/models/User";
import Collapse from "js/components/Shared/Collapsable";

const dataTable = props => {
  const {
    match = {},
    initialFilter = {},
    sort = {},
    rowsPerPage: rowsPerPageProp = 10,
    disabledItems = [],
    selectedItems = [],
    computedMatch = {},
    storage,
    initialValues,
    idPrograma,
    onDeselectAll = () => undefined,
    onSelectItem = () => undefined,
    dispatchAction = () => undefined,
    getTipo,
    filter: filterProps = [],
    defaultHeader,
    advancedFilter: AdvancedFilter,
    columnData,
    showHeader = true,
    actions = [],
    actionsCustom = [],
    toolbarActions = [],
    deleteAction = () => undefined,
    buttons = [],
    showPagination = true,
    footer = [],
    pathId,
    actionConditionVariable,
    actionConditionValues,
    client,
    query,
    conGerencia
  } = props;

  // Inicialización de filtros y estado
  const {
    params: {
      id,
      idProveedor,
      idUsuario,
      idProducto,
      idCampana,
      idBeneficio,
      codigo,
      idSegmento
    } = {}
  } = match;

  let filterInit = { ...initialFilter };

  let feProgramId;
  const inBackOffice = window.location.pathname.indexOf("admin") !== -1;
  if (!inBackOffice) {
    feProgramId = parseInt(localStorage.getItem("idPrograma"));
  }

  if (id) {
    filterInit.idPrograma = parseInt(id) || id;
    filterInit.idsProgramas = [parseInt(id) || id];
  } else if (feProgramId) {
    filterInit.idPrograma = parseInt(feProgramId) || feProgramId;
    filterInit.idsProgramas = [parseInt(feProgramId) || feProgramId];
  }

  if (idProveedor)
    filterInit.idProveedor = parseInt(idProveedor) || idProveedor;
  if (idUsuario) filterInit.idUsuario = parseInt(idUsuario) || idUsuario;
  if (idProducto) filterInit.idProducto = parseInt(idProducto) || idProducto;
  if (idCampana) filterInit.idCampana = parseInt(idCampana) || idCampana;
  if (idBeneficio)
    filterInit.idBeneficio = parseInt(idBeneficio) || idBeneficio;
  if (codigo) {
    filterInit.codigo = codigo;
  } else {
    const feCodidgo =
      computedMatch && computedMatch.params && computedMatch.params.codigo
        ? computedMatch.params.codigo
        : null;
    if (feCodidgo) {
      filterInit.codigo = parseInt(feCodidgo) || feCodidgo;
    }
  }

  // Estados
  const [selected, setSelected] = useState(selectedItems);
  const [disabled, setDisabled] = useState(disabledItems);
  const [data, setData] = useState(null);
  const [itemPopUpId, setItemPopUpId] = useState(undefined);
  const [dialogPopUpId, setDialogPopUpId] = useState(undefined);
  const [order, setOrder] = useState(sort.order);
  const [orderBy, setOrderBy] = useState(sort.orderBy);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageProp);
  const [filter, setFilter] = useState(filterInit);
  const [expanded, setExpanded] = useState(false);

  // Para mantener el valor de inBackOffice y feProgramId
  const [stateInBackOffice] = useState(inBackOffice);
  const [stateFeProgramId] = useState(parseInt(feProgramId) || feProgramId);

  // Fetch de datos
  const _fetchData = useCallback(
    async ({
      order: orderParam,
      orderBy: orderByParam,
      page: pageParam,
      rowsPerPage: rowsPerPageParam,
      filter: filterParam
    }) => {
      let filterToUse = filterParam || filter;
      if (filterToUse) {
        if (filterToUse.idCanje)
          filterToUse.idCanje = parseInt(filterToUse.idCanje);
        if (filterToUse.idProducto)
          filterToUse.idProducto = parseInt(filterToUse.idProducto);
      }
      const filtered = plainObject(filterToUse);
      await client
        .query({
          query: query,
          fetchPolicy: "network-only",
          variables: {
            order: orderParam || order,
            orderBy: orderByParam || orderBy,
            page: pageParam || page,
            rowsPerPage: rowsPerPageParam || rowsPerPage,
            ...(Object.keys(filtered).length !== 0 ? filtered : filter)
          }
        })
        .then(res => {
          setData(res.data || data);
          setOrder(orderParam || order);
          setOrderBy(orderByParam || orderBy);
          setPage(pageParam || page);
          setRowsPerPage(rowsPerPageParam || rowsPerPage);
          setFilter(filterParam || filter);
          if (dispatchAction) {
            dispatchAction(getTipo(res.data).itemsPagina);
          }
        });
    },
    [
      client,
      query,
      order,
      orderBy,
      page,
      rowsPerPage,
      filter,
      data,
      dispatchAction,
      getTipo
    ]
  );

  // componentDidMount
  useEffect(() => {
    const useFilterService =
      AuthService.getUltimaURL().indexOf(
        window.location.pathname.split("/").pop()
      ) > -1;
    const filtro = useFilterService && FilterService.getFilter(storage);

    if (props.disabled) {
      setDisabled(disabled);
    }
    if (storage && filtro) {
      setSelected(filtro.selected);
    }

    if (initialValues && initialValues.cuentaCorriente_usuario_gerencia) {
      filtro.cuentaCorriente_usuario_gerencia =
        initialValues.cuentaCorriente_usuario_gerencia;
      setFilter(filtro);
    }
    //FIXME: hack para q no cargue TODOS los programas si no tiene el permiso
    // (AuthService.hasPerms([Roles.PROGRAMA_LISTA]) || props.forceFetch) &&
    //   _fetchData({ ...filtro });
    // eslint-disable-next-line
  }, []);

  // componentWillReceiveProps
  useEffect(
    () => {
      setSelected(selectedItems);
      setDisabled(disabledItems);
      if (props.initialFilter) {
        const filterCopy = { ...filter };
        filterCopy.cuentaCorriente_usuario_gerencia =
          props.initialFilter.cuentaCorriente_usuario_gerencia;
        searchAndSet(filterCopy);
      }
      // eslint-disable-next-line
    },
    [selectedItems, disabledItems, props.initialFilter]
  );

  // componentWillUnmount
  useEffect(() => {
    return () => {
      if (storage) {
        FilterService.setFilter(storage, {
          order,
          orderBy,
          page,
          rowsPerPage,
          filter,
          selected
        });
      }
    };
    // eslint-disable-next-line
  }, []);

  // Handlers
  const handleRequestSort = (event, property) => {
    const orderByNew = property;
    let orderNew = "desc";
    if (orderBy === property && order === "desc") {
      orderNew = "asc";
    }
    _fetchData({ order: orderNew, orderBy: orderByNew });
  };

  const handleSelectAllClick = (data, event, checked) => {
    const key = pathId ? pathId : Object.keys(data[0])[0];
    let keys = null;
    if (key.indexOf(".") !== -1) {
      keys = key.split(".");
    }
    if (checked) {
      const selectedArr = [];
      data.forEach(n => {
        if (actionConditionVariable) {
          actionConditionValues.forEach(value => {
            if (n[actionConditionVariable] === value) {
              selectedArr.push(
                key.indexOf(".") !== -1 ? n[keys[0]][keys[1]] : n[key]
              );
            }
          });
        } else {
          selectedArr.push(
            key.indexOf(".") !== -1 ? n[keys[0]][keys[1]] : n[key]
          );
        }
      });
      setSelected(selectedArr);
      if (storage) {
        FilterService.setFilter(storage, {
          order,
          orderBy,
          page,
          rowsPerPage,
          filter,
          selected: selectedArr
        });
      }
      return;
    }
    setSelected([]);
  };

  const handleDeselectAllClick = () => {
    setSelected([]);
    onDeselectAll();
  };

  const handleClick = (event, item) => {
    const key = pathId ? pathId : Object.keys(item)[0];
    let id = null;
    if (key.indexOf(".") !== -1) {
      let keys = key.split(".");
      id = item[keys[0]][keys[1]];
    } else {
      id = item[key];
    }
    const selectedIndex = selected.indexOf(id);
    let newSelected = [...selected];
    if (selectedIndex === -1) {
      newSelected.push(id);
      onSelectItem(newSelected, { ...item });
    } else {
      newSelected.splice(selectedIndex, 1);
      onSelectItem(newSelected, id);
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, pageParam) => {
    _fetchData({ page: parseInt(pageParam, 10) + 1 });
  };

  const handleChangeRowsPerPage = event => {
    _fetchData({ rowsPerPage: event.target.value, page: 1 });
  };

  const handleKey = e => {
    if (e.keyCode === 13) search();
  };

  const togglePopUp = (itemPopUpId, dialogPopUpId) => {
    setItemPopUpId(itemPopUpId);
    setDialogPopUpId(dialogPopUpId);
  };

  const submitValue = e => {
    const obj = { ...filter };
    const objZona = {};
    const objLocalidad = {};

    if (Array.isArray(e.target.value) && e.target.value.length === 0) {
      delete obj[e.target.name];
    } else {
      obj[e.target.name] = e.target.value;
    }
    const paisActual = filter && filter.idPais;

    if (e.target.name === "idPais" && e.target.value !== paisActual) {
      objZona["idZona"] = undefined;
      objLocalidad["idLocalidad"] = undefined;
    }
    if (e.target.name === "idZona" && e.target.value === "") {
      objLocalidad["idLocalidad"] = undefined;
    }

    setFilter({ ...obj, ...objZona, ...objLocalidad });
  };

  const clear = () => {
    const cuentaCorriente_tipo = filter.cuentaCorriente_tipo;
    const cuentaCorriente_usuario_gerencia =
      filter["cuentaCorriente_usuario_gerencia"] &&
      !AuthService.hasPerms([Roles.CC_SELECT_GERENCIA])
        ? filter.cuentaCorriente_usuario_gerencia
        : undefined;

    let fianalIdPrograma = undefined;
    let finalIdsProgramas = undefined;

    if (id || idPrograma) {
      fianalIdPrograma =
        parseInt(id) || id || parseInt(idPrograma) || idPrograma;
      finalIdsProgramas = [
        parseInt(id) || id || parseInt(idPrograma) || idPrograma
      ];
    }

    if (!stateInBackOffice) {
      fianalIdPrograma = parseInt(stateFeProgramId) || stateFeProgramId;
      finalIdsProgramas = [parseInt(stateFeProgramId) || stateFeProgramId];
    }

    const filterClear = {
      idPrograma: fianalIdPrograma,
      idsProgramas: finalIdsProgramas,
      idSegmento: parseInt(idSegmento) || idSegmento
    };

    if (idProveedor)
      filterClear.idProveedor = parseInt(idProveedor) || idProveedor;
    if (idUsuario) filterClear.idUsuario = parseInt(idUsuario) || idUsuario;
    if (idProducto) filterClear.idProducto = parseInt(idProducto) || idProducto;
    if (idCampana) filterClear.idCampana = parseInt(idCampana) || idCampana;
    if (idBeneficio)
      filterClear.idBeneficio = parseInt(idBeneficio) || idBeneficio;
    if (codigo) {
      filterClear.codigo = codigo;
    } else {
      const feCodidgo =
        computedMatch && computedMatch.params && computedMatch.params.codigo
          ? computedMatch.params.codigo
          : null;
      if (feCodidgo) {
        filterClear.codigo = feCodidgo;
      }
    }

    _fetchData({
      filter: {
        ...filterClear,
        cuentaCorriente_tipo,
        cuentaCorriente_usuario_gerencia
      }
    });
  };

  const getHeaderQueryString = ({ queryStringMatcher = {} }) => {
    let filterCopy = { ...filter };
    Object.keys(queryStringMatcher).map(key => {
      if (queryStringMatcher[key])
        filterCopy[queryStringMatcher[key]] = filterCopy[key];
      return delete filterCopy[key];
    });
    Object.keys(filterCopy).forEach(
      key => filterCopy[key] === undefined && delete filterCopy[key]
    );
    return filterCopy;
  };

  const search = () => {
    let filterCopy = { ...filter };
    Object.keys(filterCopy).forEach(key => {
      if (filterCopy[key] === "TODOS") delete filterCopy[key];
    });
    _fetchData({
      filter: {
        ...filterCopy
      }
    });
    setExpanded(false);
  };

  const searchAndSet = filterParam => {
    let filterCopy = { ...filterParam };
    Object.keys(filterCopy).forEach(key => {
      if (filterCopy[key] === "TODOS") delete filterCopy[key];
    });
    _fetchData({
      filter: {
        ...filterCopy
      }
    });
    setExpanded(false);
    setFilter(filterCopy);
  };

  const handleCollapse = () => setExpanded(prev => !prev);

  // Render
  return (
    <div tabIndex="0" onKeyDown={handleKey}>
      {showHeader && (
        <Header
          values={defaultHeader}
          filter={getHeaderQueryString(defaultHeader)}
          refetch={() => search()}
        />
      )}
      {!!filterProps.length && (
        <DefaultFilter
          filter={filterProps}
          value={filter}
          submitValue={submitValue}
        />
      )}
      {!!AdvancedFilter && (
        <Collapse
          clear={clear}
          search={search}
          expanded={expanded}
          onChange={handleCollapse}
          title="Filtros"
        >
          <AdvancedFilter
            value={filter}
            submitValue={submitValue}
            search={search}
            conGerencia={conGerencia}
            idPrograma={idPrograma}
          />
        </Collapse>
      )}
      {!data && <SplashScreen />}
      {data && (
        <EnhancedTable
          refetch={_fetchData}
          columnData={columnData}
          labelDisplayedRows={props.labelDisplayedRows}
          data={getTipo(data).itemsPagina}
          page={showPagination ? getTipo(data).infoPagina.numeroPagina : 0}
          total={showPagination ? getTipo(data).infoPagina.total : 0}
          totalDisabledItems={size(disabledItems) || 0}
          handleRequestSort={handleRequestSort}
          handleSelectAllClick={handleSelectAllClick.bind(
            null,
            getTipo(data).itemsPagina
          )}
          handleClick={handleClick}
          handleDeselectAllClick={handleDeselectAllClick}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          footer={footer}
          actions={actions}
          actionsCustom={actionsCustom}
          toolbarActions={toolbarActions}
          hanleDeleteAction={deleteAction.bind(this)}
          state={{
            selected,
            disabled,
            data,
            itemPopUpId,
            dialogPopUpId,
            order,
            orderBy,
            page,
            rowsPerPage,
            filter,
            expanded,
            inBackOffice: stateInBackOffice,
            feProgramId: stateFeProgramId
          }}
          onTableChange={() => search()}
          pathId={pathId}
          actionConditionVariable={actionConditionVariable}
          actionConditionValues={actionConditionValues}
          togglePopUp={togglePopUp}
          itemPopUpId={itemPopUpId}
          dialogPopUpId={dialogPopUpId}
          showPagination={showPagination}
        />
      )}
      {data && (
        <ButtonBar
          onTableChange={() => search()}
          buttons={buttons}
          total={showPagination ? getTipo(data).infoPagina.total : 0}
          filters={filter}
          selected={selected.length}
        />
      )}
    </div>
  );
};

dataTable.propTypes = {
  storage: PropTypes.string,
  query: PropTypes.object.isRequired,
  columnData: PropTypes.array.isRequired,
  showHeader: PropTypes.bool,
  defaultHeader: PropTypes.object,
  sort: PropTypes.object,
  filter: PropTypes.array.isRequired,
  advancedFilter: PropTypes.func,
  getTipo: PropTypes.func.isRequired,
  actions: PropTypes.array,
  actionsCustom: PropTypes.array,
  buttons: PropTypes.array,
  toolbarActions: PropTypes.array,
  disabledItems: PropTypes.array,
  selectedItems: PropTypes.array,
  onSelectItem: PropTypes.func,
  onDeselectAll: PropTypes.func,
  deleteAction: PropTypes.func,
  dispatchAction: PropTypes.func,
  computedMatch: PropTypes.object,
  showPagination: PropTypes.bool
};

dataTable.defaultProps = {
  storage: null,
  showHeader: true,
  initialFilter: {},
  filter: [],
  advancedFilter: undefined,
  sort: {},
  actions: [],
  footer: [],
  actionsCustom: [],
  buttons: [],
  toolbarActions: [],
  disabledItems: [],
  selectedItems: [],
  onSelectItem: () => undefined,
  onDeselectAll: () => undefined,
  deleteAction: () => undefined,
  dispatchAction: () => undefined,
  computedMatch: {},
  showPagination: true
};
export default dataTable;
